module.exports = __webpack_public_path__ + "static/media/phone_icon.5f1c9db2.svg";